/* eslint-disable  */
//@ts-nocheck

import React from 'react';
import VideoPlayer from 'react-hls';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import Spinner from './Spinner';

import * as mux from './video-library/mux';
import { Typography } from '@mui/material';

class VideoLibraryModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      videos: [],
      loading: false,
    };

    this.getLibraryData = this.getLibraryData.bind(this);
    this.addFromLibrary = this.addFromLibrary.bind(this);
  }

  componentDidMount() {
    this.setState({
      loading: true,
    });
    this.getLibraryData().then((filtered) =>
      this.setState({ videos: filtered, loading: false }),
    );
  }

  async getLibraryData() {
    try {
      const response = await mux.listAllVideoFiles({
        influencerId: this.props.influencerId,
      });
      const filtered =
        response && response.data && response.data.length
          ? response.data.filter((e) => e.status === 'PROCESSING_FINISHED')
          : [];
      return filtered;
    } catch (e) {
      console.log('[VideoLibraryModal] Error fetching Video Library list.', e);
    }
    return [];
  }

  addFromLibrary(data) {
    this.props.addFromLibrary(data);
    this.props.closeLibrary();
  }

  render() {
    const items = this.state.videos.map((v, i) => {
      return (
        <VideoLibraryModalItem
          data={v}
          addFromLibrary={this.addFromLibrary}
          key={i}
          source={this.props.source}
        />
      );
    });

    return (
      <Modal
        isOpen={this.props.isLibraryOpen}
        onRequestClose={this.props.closeLibrary}
        appElement={document.getElementById('app')}
        contentLabel={'Add To Library'}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, .6)',
            zIndex: 99999,
            textAlign: 'center',
          },
          content: {
            top: '20px',
            left: '20px',
            right: '20px',
            bottom: '20px',
            margin: '0 auto 0 auto',
            maxWidth: '800px',
            maxHeight: '520px',
            borderRadius: '5px',
            border: 0,
            zIndex: 99999,
            padding: 0,
            WebkitOverflowScrolling: 'touch',
          },
        }}
      >
        <div className="legacy">
          <div className="legacy_page_styles">
            <div className="modalAddToLibrary">
              <div className="modalAddToVideoLibraryHeader">
                <Typography variant="h1">Add video 3</Typography>
                <a
                  onClick={this.props.closeLibrary}
                  className="dlete-item dlete-darker icon-remove"
                ></a>
              </div>
              {this.state.loading ? (
                <Spinner color={`#171e33`} style={{ marginTop: '11rem' }} />
              ) : (
                <div className="modalAddToVideoLibraryList">
                  {items && items.length ? (
                    items
                  ) : (
                    <div
                      style={{
                        textAlign: 'center',
                        width: '70%',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                      }}
                    >
                      <span>
                        You haven’t uploaded any videos to the{' '}
                        <strong>Video Library</strong> yet. <br />
                        Go to the <strong>Video Library</strong> and select{' '}
                        <strong>Upload</strong> in the top right corner to begin
                        uploading. Once the video is uploaded & processed, it
                        will be available to select here.
                      </span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

class VideoLibraryModalItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
    this.addFromLibrary = this.addFromLibrary.bind(this);
    this.playVideo = this.playVideo.bind(this);
  }

  addFromLibrary() {
    this.props.addFromLibrary(this.props.data);
  }

  playVideo() {
    this.setState({
      clicked: true,
    });
  }

  render() {
    return (
      <div key={this.props.id} className="modalAddToVideoLibraryItem">
        <div className="trinity">
          <div className="first" style={{ position: 'relative' }}>
            {this.state.clicked ? (
              <VideoPlayer
                url={this.props.data.video || this.props.data.media?.videoUrl}
                videoProps={{ autoPlay: true }}
              />
            ) : (
              <img
                src={
                  this.props.data.thumbnail ||
                  this.props.data.media.videoThumbnailUrl
                }
                style={{
                  height: '150px',
                  width: '150px',
                  marginLeft: '10px',
                  marginTop: '10px',
                  marginBottom: '5px',
                  borderRadius: '5px',
                  objectFit: 'contain',
                  backgroundColor: '#000',
                }}
              />
            )}
            <FontAwesomeIcon
              onClick={this.playVideo}
              icon={faPlay}
              style={{
                display: this.state.clicked ? 'none' : 'inline-block',
                position: 'absolute',
                top: '50%',
                left: '50%',
                marginLeft: '10px',
                transform: 'translate(-50%, -50%)',
                color: '#fff',
                fontSize: '2rem',
                cursor: 'pointer',
              }}
            />
          </div>
          <div className="second">
            {this.props.data.title ? (
              <strong>
                {this.props.data.title ? this.props.data.title : '-'}
              </strong>
            ) : null}
            <ul>
              {Intl.DateTimeFormat('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }).format(new Date(this.props.data.createdAt))}
            </ul>
            <ul>{mux.formatFileSizeInBytes(this.props.data.fileSize)}</ul>
            <ul>{mux.formatDuration(this.props.data.duration)}</ul>
          </div>
          <div className="third">
            <a
              className="actionLink button flat-button"
              onClick={this.addFromLibrary}
            >
              Add to {this.props.source}
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default VideoLibraryModal;
